var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isDaumSearch || _vm.articles.length > 0
    ? _c("div", { staticClass: "view_group" }, [
        _c("h3", { staticClass: "tit_group" }, [
          _c("em", { staticClass: "emph_group" }, [
            _vm._v(_vm._s(_vm.mainTitle)),
          ]),
          _vm._v(_vm._s(_vm.subTitle) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "paging_group" }, [
          _c(
            "span",
            { staticClass: "inner_paging" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.pageMessages, function (message, index) {
                return _c("span", { class: _vm.pageClass(index) }, [
                  _vm._v(_vm._s(message)),
                ])
              }),
              _vm._v(" "),
              _vm._m(1),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group_slide", attrs: { id: "linkageContents" } },
          [
            _c(
              "swiper",
              {
                ref: "swiper",
                attrs: { options: _vm.swiperOptions },
                on: { slideChange: _vm.onSlide },
              },
              _vm._l(_vm.pages, function (articles) {
                return _c("swiper-slide", [
                  _c(
                    "ul",
                    { staticClass: "list_group" },
                    _vm._l(articles, function (article) {
                      return _c("text-item", {
                        attrs: { article: article, config: _vm.config },
                      })
                    }),
                    1
                  ),
                ])
              }),
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn_page btn_prev",
        attrs: { type: "button", id: "btn_prev" },
      },
      [_c("span", { staticClass: "ico_cafe ico_prev" }, [_vm._v("이전")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn_page btn_next",
        attrs: { type: "button", id: "btn_next" },
      },
      [_c("span", { staticClass: "ico_cafe ico_next" }, [_vm._v("다음")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }